export const dielines = [
    {
        img: 'corrugated--211--dieline.png',
        requirements: {
            type__name: 'corrugated',
            'structural-design__code': 'fefco-211'
        }
    },
    {
        img: 'corrugated--215--dieline.png',
        requirements: {
            type__name: 'corrugated',
            'structural-design__code': 'fefco-215'
        }
    },
    {
        img: 'corrugated--330--dieline.png',
        requirements: {
            type__name: 'corrugated',
            'structural-design__code': 'fefco-330'
        }
    },
    {
        img: 'corrugated--426--dieline.png',
        requirements: {
            type__name: 'corrugated',
            'structural-design__code': 'fefco-426'
        }
    },
    {
        img: 'corrugated--703--dieline.png',
        requirements: {
            type__name: 'corrugated',
            'structural-design__code': 'fefco-703'
        }
    },
    {
        img: 'corrugated--711--dieline.png',
        requirements: {
            type__name: 'corrugated',
            'structural-design__code': 'fefco-711'
        }
    },
    {
        img: 'corrugated--713--dieline.png',
        requirements: {
            type__name: 'corrugated',
            'structural-design__code': 'fefco-713'
        }
    },
    {
        img: 'corrugated--carrier-box-yope--dieline.png',
        requirements: {
            type__name: 'corrugated',
            'structural-design__code': 'carrier-box-yope-fefco-217-modified'
        }
    },
    {
        img: 'cartonboard--cakebox--dieline.png',
        requirements: {
            type__name: 'cartonboard',
            'structural-design__code': 'cakebox'
        }
    },
    {
        img: 'cartonboard--cakebox-auto-bottom-with-handle-min.png',
        requirements: {
            type__name: 'cartonboard',
            'structural-design__code': 'cakebox-auto-bottom-with-handle'
        }
    },
    {
        img: 'cartonboard--pillow-box--dieline.png',
        requirements: {
            type__name: 'cartonboard',
            'structural-design__code': 'pillow-box'
        }
    },
    {
        img: 'cartonboard--sleeve--dieline.png',
        requirements: {
            type__name: 'cartonboard',
            'structural-design__code': 'sleeve'
        }
    },
    {
        img: 'cartonboard--two-piece-double-bottom-min.png',
        requirements: {
            type__name: 'cartonboard',
            'structural-design__code': 'two-piece-double-bottom'
        }
    },
    {
        img: 'corrugated--mailer-box--dieline.png',
        requirements: {
            type__name: 'corrugated',
            'structural-design__code': 'mailer-box'
        }
    },
    {
        img: 'corrugated--shipping-box--dieline.png',
        requirements: {
            type__name: 'corrugated',
            'structural-design__code': 'shipping-box'
        }
    }
];
//# sourceMappingURL=dielines.js.map